
import { RevButton, RevDivider } from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { fetchReviewsRateByProduct } from '@http/endpoints'
import { logReviewsError } from '@reviews/helpers'

import translations from './OutOfStock.translations'
import Divider from './components/Divider'
import Product from './components/Product'
import ProductAlternative from './components/ProductAlternative'
import ProductAlternativeSkeleton from './components/ProductAlternativeSkeleton'

export default {
  components: {
    RevButton,
    RevDivider,
    Divider,
    Product,
    ProductAlternativeSkeleton,
    ProductAlternative,
  },
  props: {
    ratings: {
      type: Object,
      required: true,
    },

    product: {
      type: Object,
      required: true,
    },

    productAlternative: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      productAlternativeRating: {},
    }
  },
  computed: {
    ...mapGetters({
      isVatIncluded: 'config/vatIncluded',
    }),
    translations: () => translations,
    image() {
      return this.product.images[0] || {}
    },
    isLoading() {
      return isEmpty(this.productAlternative)
    },
    productSubTitle() {
      return this.product.subTitleElements.join(' - ')
    },
    productAlternativeImage() {
      return this.productAlternative.product?.images
        ? this.productAlternative.product.images[0]
        : ''
    },
    productAlternativeLink() {
      return this.productAlternative.product?.link
    },
    productAlternativeTitle() {
      return {
        title: this.productAlternative.product?.title,
        subTitle: this.productAlternative.product?.subTitles?.join(' - '),
      }
    },
    productAlternativePrice() {
      return {
        price: this.$t.price(this.productAlternative.product?.listing?.price),
        label: this.$t(translations.recommendedProductPriceFrom),
        reference: this.$t.price(
          this.productAlternative.product?.referencePrice,
        ),
      }
    },

    alternativeProductExist() {
      return !isEmpty(this.productAlternative.product)
    },

    landingLink() {
      return this.productAlternative.landing?.link
    },

    isVisibleWithoutAlternativeProduct() {
      return !this.isLoading && !this.alternativeProductExist
    },

    isVisibleWithAlternativeProduct() {
      return this.isLoading || this.alternativeProductExist
    },
  },
  watch: {
    async isLoading(newValue) {
      if (!newValue && this.alternativeProductExist) {
        const { payload } = await this.$store
          .dispatch('http/request', {
            request: fetchReviewsRateByProduct,
            pathParams: { productId: this.productAlternative.product.uuid },
          })
          .catch((err) => {
            logReviewsError({ tags: ['ProductPage', 'OutOfStock'], err })

            return { payload: {} }
          })

        this.productAlternativeRating = payload
      }
    },
  },
}
